import { cn } from "@klarify/ui/lib/utils";

export function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			className={cn(
				"animate-pulse rounded-md bg-klarify-neutral-500/10",
				className,
			)}
			{...props}
		/>
	);
}

export function SkeletonText({
	className,
	...props
}: React.ComponentProps<"div">) {
	return (
		<div
			className={cn("space-y-6", className)}
			{...props}
		>
			<div className="space-y-3.5">
				<Skeleton className="h-6 w-[50%]" />
				<div className="space-y-1.5">
					<Skeleton className="h-3 w-[90%]" />
					<Skeleton className="h-3 w-[85%]" />
					<Skeleton className="h-3 w-[95%]" />
				</div>
			</div>

			<div className="space-y-3.5">
				<Skeleton className="h-6 w-[35%]" />
				<div className="space-y-1.5">
					<Skeleton className="h-3 w-[80%]" />
					<Skeleton className="h-3 w-[88%]" />
					<Skeleton className="h-3 w-[75%]" />
				</div>
			</div>

			<div className="space-y-3.5">
				<Skeleton className="h-6 w-[40%]" />
				<div className="space-y-1.5">
					<Skeleton className="h-3 w-[92%]" />
					<Skeleton className="h-3 w-[85%]" />
					<Skeleton className="h-3 w-[78%]" />
				</div>
			</div>
		</div>
	);
}

export function SkeletonCards({
	className,
	...props
}: React.ComponentProps<"div">) {
	return (
		<div
			className={cn("flex flex-col gap-4 py-2", className)}
			{...props}
		>
			{Array.from({ length: 6 }).map((_, i) => (
				<div
					className="flex w-full items-center gap-4"
					key={i}
				>
					<Skeleton className="h-12 w-12 shrink-0 rounded-full" />
					<div className="w-full space-y-2">
						<Skeleton className="h-3 w-[calc(100%-84px)]" />
						<Skeleton className="h-3 w-[calc(100%-32px)]" />
					</div>
				</div>
			))}
		</div>
	);
}

// Route loading.tsx files render inside their layout's content boundary, not
// the viewport. h-full fills that boundary; h-screen would overflow it.
export function FullPageSkeleton({
	className,
	...props
}: React.ComponentProps<"div">) {
	return (
		<div
			className={cn("flex h-full gap-4", className)}
			{...props}
		>
			<Skeleton className="h-full flex-1" />
		</div>
	);
}
